import FullPageLoader from "../../components/full-page-loader";
import useLaunchController from "./useLaunchController";

const Launch = () => {
  useLaunchController();

  return <FullPageLoader />;
};

export default Launch;
